import React from "react";
import styled from "styled-components";

import SkeletonBox from "../SkeletonBox";

const StyledFieldSet = styled.fieldset`
  text-align: left;
  margin: 1em 0 2em;
  min-width: 0;
  width: 100%;
  padding: 0 1.19em;
  border-bottom: ${(props) => (props.border ? `1px solid #d6d6d6` : `0`)};
  @media (min-width: 768px) {
    padding: 0 2.19em;
  }
`;

const StyledLegend = styled.legend`
  font-size: 1.25em;
  border-bottom: none;
  margin-left: 0.25em;
  margin-right: 0.25em;
  margin-bottom: 0.1em;
  font-weight: 700;
  display: block;
  width: 100%;
  padding: 0;
  color: ${(props) => props.theme.color.darkGray};
  border: 0;
`;

function FieldSet({ children, legend, ...rest }) {
  return (
    <StyledFieldSet {...rest}>
      <SkeletonBox>
        <StyledLegend>{legend}</StyledLegend>
      </SkeletonBox>
      {children}
    </StyledFieldSet>
  );
}

export default FieldSet;
